import {contextPath} from "site";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

import {ThirdPartyDataSharingCustomerAircraft} from './third-party-data-sharing-customer-aircraft';

const apiURL = `${contextPath}/api`;
const thirdPartyDataSharingURL = `${apiURL}/third-party-data-sharing`;

@Injectable()
export class ThirdPartyDataSharingService {
	constructor(private readonly http: HttpClient) {}

	/**
	 * Get the current third party sharing records for a given customer aircraft
	 * @param customerAircraftUuid UUID of the customer aircraft
	 * @returns Array of {@link ThirdPartyDataSharingCustomerAircraft} objects
	 */
	getThirdPartyDataSharingByCustomerAircraft(customerAircraftUuid: string):
		Observable<ThirdPartyDataSharingCustomerAircraft[]> {

		return this.http.get<ThirdPartyDataSharingCustomerAircraft[]>(
			`${thirdPartyDataSharingURL}/customer-aircraft/${customerAircraftUuid}/third-parties`,
		).map(response => (response as Array<any>)
			.map(json => ThirdPartyDataSharingCustomerAircraft.fromJSON(json)));

	}

	/**
	 * Add a new record indicating that a specific customer aircraft would like to share
	 * third party data with a specific third party
	 * @param customerAircraftUuid  The UUID of the specific customer aircraft
	 * @param thirdPartyDataSharingCustomerAircraft  The record to insert (specifies the specific third party)
	 * @returns An {@link ThirdPartyDataSharingCustomerAircraft} object that was just inserted into the database
	 */
	createThirdPartyDataSharingByCustomerAircraft(
		customerAircraftUuid: string,
		thirdPartyDataSharingCustomerAircraft: ThirdPartyDataSharingCustomerAircraft):
		Observable<ThirdPartyDataSharingCustomerAircraft> {

		return this.http.post<ThirdPartyDataSharingCustomerAircraft>(
			`${thirdPartyDataSharingURL}/customer-aircraft/${customerAircraftUuid}/third-parties`,
			thirdPartyDataSharingCustomerAircraft
		).map(response => ThirdPartyDataSharingCustomerAircraft.fromJSON(response));
	}

	/**
	 * Remove a record from the database to indicate that a specific customer aircraft would like
	 * to stop sharing data with a specific third party
	 * @param customerAircraftUuid  The UUID of the specific customer aircraft
	 * @param thirdPartyUuid  The UUID of the specific third party to stop sharing with
	 * @returns void or throws an error
	 */
	deleteThirdPartyDataSharingByCustomerAircraftAndThirdPartyUuid(
		customerAircraftUuid: string,
		thirdPartyUuid: string):
		Observable<void> {

		return this.http.delete<void>(
			`${thirdPartyDataSharingURL}/customer-aircraft/${customerAircraftUuid}/third-parties/${thirdPartyUuid}`,
		);
	}
}
